/**
 * Browser error reporting to GlitchTip (Sentry-protocol compatible).
 *
 * Configured at build time (REACT_APP_* is baked into the bundle, see
 * vite.config.ts); an empty REACT_APP_SENTRY_DSN disables it entirely.
 *
 *   REACT_APP_SENTRY_DSN          GlitchTip frontend project DSN (empty = off)
 *   REACT_APP_SENTRY_ENVIRONMENT  defaults to the Vite mode (production/development)
 *
 * Reports uncaught errors and unhandled promise rejections (SDK defaults)
 * plus React render crashes via the ErrorBoundary in index.tsx. Failed API
 * calls are not reported here: the backend already reports its own 5xx.
 * GlitchTip does not support sessions, so session tracking is removed.
 */

import * as Sentry from '@sentry/react';

const dsn = (import.meta.env.REACT_APP_SENTRY_DSN || '').trim();

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.REACT_APP_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    integrations: (defaults) => defaults.filter((i) => i.name !== 'BrowserSession'),
  });
}

export { Sentry };
